module.exports = __webpack_public_path__ + "static/img/cysw06_02.215074c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/cysw/cysw06_02.jpg
// module id = L5Af
// module chunks = 0